module.exports = __webpack_public_path__ + "img/08-326x184-lafalce.f7767c30.jpg";